import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';
import { HomeService } from '../../home/home.service';
import { Injectable } from '@angular/core';

@Injectable()
export class RecurringDepositsService {

  constructor(private http: HttpClient, private homeService: HomeService) { }

  recurringDepositData(): Observable<any> {
    return this.http.post<any>(resturlConstants.RDUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-type', 'application/JSON')
          .set('Authorization', this.homeService.getAuthHeader())
      });
  }
}

